import { useState, useEffect } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";

export const useCompaniesCount = () => {
  const [count, setCount] = useState<number | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchCompaniesCount = async () => {
      try {
        const response = await axiosInstance.get(
          "companies/companies/total_count/",
        );

        setCount(response.data.total_count);
      } catch (err) {
        if (isAxiosError(err)) {
          setError(err.message);
        } else if (err instanceof Error) {
          setError(err.message);
        } else {
          setError("An unknown error occurred.");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchCompaniesCount();
  }, []);

  return { count, loading, error };
};
